import AccessCode from './AccessCode';
import ChangePassword from './ChangePassword';
import LoginForm from './LoginForm';
import PageWrapper from './PageWrapper/PageWrapper';
import RecoverPassword, { EmailSentPage } from './RecoverPassword';
import RegisterUserGroup from './Registration/RegisterUserGroup';
import {
  ConfirmEmail as RegisterConfirmEmail,
  WaitForApproval as RegisterWaitForApproval,
} from './Registration/Step2';
import EmailRegistrationForm from './Registration/EmailRegistrationForm';
import RegisterForAccess from './Registration/RegisterForAccess';
import OutOfOffice from './OutOfOffice';

export default {
  AccessCode,
  ChangePassword,
  EmailRegistrationForm,
  EmailSentPage,
  LoginForm,
  PageWrapper,
  RecoverPassword,
  RegisterUserGroup,
  RegisterConfirmEmail,
  RegisterForAccess,
  RegisterWaitForApproval,
  OutOfOffice,
};
